import { NavLink } from "react-router-dom";
import JobZImage from "../../../common/jobz-img";
import SectionPagination from "../../public-user/sections/common/section-pagination";
import { useEffect, useState } from "react";
import { loadScript } from "../../../../globals/constants";
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet-async';
import { useTranslation } from "react-i18next";

const getColorClass = (char) => {
    if (!char) return "bg-default";
    const letter = char.toUpperCase();
    const colors = {
        A: "bg-red", B: "bg-blue", C: "bg-green", D: "bg-orange", E: "bg-purple",
        F: "bg-teal", G: "bg-pink", H: "bg-indigo", I: "bg-yellow", J: "bg-cyan",
        K: "bg-lime", L: "bg-rose", M: "bg-amber", N: "bg-violet", O: "bg-emerald",
        P: "bg-fuchsia", Q: "bg-sky", R: "bg-gray", S: "bg-zinc", T: "bg-stone",
        U: "bg-neutral", V: "bg-blue-500", W: "bg-orange-600", X: "bg-indigo-500",
        Y: "bg-pink-600", Z: "bg-teal-600",
    };
    return colors[letter] || "bg-default";
};

function CanJobFinderPage() {
    const { t } = useTranslation();
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [city, setCity] = useState("");
    const [jobTitle, setJobTitle] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [hasSearched, setHasSearched] = useState(false);
    const itemsPerPage = 5;
    const [loading, setLoading] = useState(false);
    const [jobs, setJobs] = useState([]);

    const handleSearch = async () => {
        // Search text required
        if (!city) {
            toast.error("Please enter city name");
            return;
        }
        if (!jobTitle) {
            toast.error("Please enter job title");
            return;
        }

        setLoading(true);
        setHasSearched(true);

        try {
            const response = await axiosInstance.get(`${API_URL}/searchJobs`, {
                params: {
                    jobTitle: jobTitle,
                    city: city,
                    page: currentPage
                }
            });

            if (response.data.status === 200) {
                const apiJobs = response.data.data || [];

                const mappedJobs = apiJobs.map((job) => ({
                    id: job.id,
                    title: job.title,
                    category: job.category?.label || "",
                    location: job.location?.display_name || "",
                    companyWebsite: job.redirect_url,
                    company: job.company?.display_name || "",
                    companyLogo: null,
                    min_salary: job.salary_min,
                    max_salary: job.salary_max,
                    contract_time: job.contract_time,
                    job_url: "/job-details"
                }));

                console.log("Mapped Jobs:", mappedJobs);

                setJobs(mappedJobs);
                setCurrentPage(1);

            } else {
                toast.error("No jobs found!");
            }
        } catch (error) {
            toast.error("Something went wrong while fetching jobs.");
            console.error("Search API Error:", error);
        }

        setLoading(false);
    };

    // useEffect(() => {
    //     loadScript("js/custom.js");

    //     const fetchAppliedJobs = async () => {
    //         try {
    //             const response = await axiosInstance.get(`${API_URL}/getJob`);
    //             if (response.data.status === 200) {
    //                 setAppliedJobs(response.data.data);
    //             }
    //         } catch (err) {
    //             console.error("Error fetching applied jobs", err);
    //         } finally {
    //             setDataLoaded(true);
    //         }
    //     };

    //     fetchAppliedJobs();
    // }, []);

    // useEffect(() => {
    //     setCurrentPage(1); // Reset to first page on new search
    // }, [searchTerm]);

    // const filteredJobs = appliedJobs.filter((job) =>
    //     `${job.title} ${job.company}`.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    // const indexOfLastItem = currentPage * itemsPerPage;
    // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    // const currentJobs = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <>
            <Helmet>
                <title>Job Finder | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>

            <div className="twm-right-section-panel candidate-save-job site-bg-gray">
                <div className="panel-body wt-panel-body p-a20 m-b30">
                    <div className="row">
                        <div className="col-12">
                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "end",
                                    flexWrap: "wrap"
                                }}
                            >
                                {/* City */}
                                <div style={{ flex: 1, minWidth: "220px" }}>
                                    <label>{t("Search City")}</label>
                                    <input
                                        type="text"
                                        placeholder={`${t("Enter city name")}...`}
                                        className="form-control"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                    />
                                </div>

                                {/* Job Title */}
                                <div style={{ flex: 1, minWidth: "220px" }}>
                                    <label>{t("Search Job Title")}</label>
                                    <input
                                        type="text"
                                        placeholder={`${t("Enter job title")}...`}
                                        className="form-control"
                                        value={jobTitle}
                                        onChange={(e) => setJobTitle(e.target.value)}
                                    />
                                </div>

                                {/* Button */}
                                <div>
                                    <button
                                        type="button"
                                        className="site-button"
                                        onClick={handleSearch}
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        {t("Search")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="twm-jobs-list-wrap">
                    {loading ? (
                        <div className="text-center my-4">
                            <div className="spinner-border site-text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : jobs.length > 0 ? (
                        <ul>
                            {jobs
                                .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                                .map((job, index) => (
                                    <li key={index}>
                                        <div className="twm-jobs-list-style1 mb-5">
                                            <div className="twm-media">
                                                {job.companyLogo ? (
                                                    <JobZImage src={job.companyLogo} alt={job.title} />
                                                ) : (
                                                    <div className={`company-logo-placeholder ${getColorClass(job.company?.charAt(0))}`}>
                                                        {job.company?.charAt(0)?.toUpperCase() || ''}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="twm-mid-content">
                                                <a
                                                    href={job.companyWebsite}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="twm-job-title"
                                                >
                                                    <h4>
                                                        {job.title}{" "}
                                                        {job.contract_time && (
                                                            <span className="twm-job-post-duration">
                                                                / {job.contract_time.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                                                            </span>
                                                        )}
                                                    </h4>
                                                </a>
                                            </div>
                                            <div className="twm-right-content">
                                                <div><span>{job.category}</span></div>
                                                <div className="twm-jobs-amount">
                                                    <span>
                                                        {job.min_salary ? `$${job.min_salary}` : ""}
                                                        {job.min_salary && job.max_salary ? " / " : ""}
                                                        {job.max_salary ? job.max_salary : ""}
                                                    </span>
                                                </div>
                                                <a
                                                    href={job.companyWebsite}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="twm-jobs-browse site-text-primary"
                                                >
                                                    {t("Apply Job")}
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                        </ul>
                        ) : hasSearched ? (
                            <p>{t("No jobs available.")}</p>
                        ) : null}
                </div>

                <SectionPagination
                    currentPage={currentPage}
                    totalItems={jobs.length}
                    itemsPerPage={itemsPerPage}
                    onPageChange={(page) => {
                        if (page >= 1 && page <= Math.ceil(jobs.length / itemsPerPage)) {
                            setCurrentPage(page);
                        }
                    }}
                />
            </div>
        </>
    );
}

export default CanJobFinderPage;

































// import { NavLink } from "react-router-dom";
// import { publicUser } from "../../../../globals/route-names";
// import JobZImage from "../../../common/jobz-img";
// import SectionRecordsFilter from "../../public-user/sections/common/section-records-filter";
// import SectionPagination from "../../public-user/sections/common/section-pagination";
// import { useEffect } from "react";
// import { loadScript } from "../../../../globals/constants";

// function CanAppliedJobsPage() {

//     const _filterConfig = {
//         prefix: "Applied",
//         type: "jobs",
//         total: "250",
//         showRange: false,
//         showingUpto: ""
//     }

//     useEffect(()=>{
//         loadScript("js/custom.js")
//     })

//     return (
//         <>
//             <div className="twm-right-section-panel candidate-save-job site-bg-gray">
//                 {/*Filter Short By*/}
//                 <SectionRecordsFilter _config={_filterConfig} />

//                 <div className="twm-jobs-list-wrap">
//                     <ul>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic1.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4>Senior Web Designer<span className="twm-job-post-duration">/ 1 days ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-green">New</span></div>
//                                     <div className="twm-jobs-amount">$2500 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic2.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4>Sr. Rolling Stock Technician<span className="twm-job-post-duration">/ 15 days ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-brown">Intership</span></div>
//                                     <div className="twm-jobs-amount">$2500 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic3.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4 className="twm-job-title">IT Department Manager<span className="twm-job-post-duration"> / 6 Month ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-purple">Fulltime</span></div>
//                                     <div className="twm-jobs-amount">$2500 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic4.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4 className="twm-job-title">Art Production Specialist   <span className="twm-job-post-duration">/ 2 days ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-sky">Freelancer</span></div>
//                                     <div className="twm-jobs-amount">$1500 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic5.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4 className="twm-job-title">Recreation &amp; Fitness Worker   <span className="twm-job-post-duration">/ 1 days ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-golden">Temporary</span></div>
//                                     <div className="twm-jobs-amount">$800 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic1.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4>Senior Web Designer<span className="twm-job-post-duration">/ 1 days ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-green">New</span></div>
//                                     <div className="twm-jobs-amount">$1000 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic2.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4>Sr. Rolling Stock Technician<span className="twm-job-post-duration">/ 15 days ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-brown">Intership</span></div>
//                                     <div className="twm-jobs-amount">$1500 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic3.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4 className="twm-job-title">IT Department Manager<span className="twm-job-post-duration"> / 6 Month ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-purple">Fulltime</span></div>
//                                     <div className="twm-jobs-amount">$2500 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                         <li>
//                             <div className="twm-jobs-list-style1 mb-5">
//                                 <div className="twm-media">
//                                     <JobZImage src="images/jobs-company/pic4.jpg" alt="#" />
//                                 </div>
//                                 <div className="twm-mid-content">
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-job-title">
//                                         <h4 className="twm-job-title">Art Production Specialist   <span className="twm-job-post-duration">/ 2 days ago</span></h4>
//                                     </NavLink>
//                                     <p className="twm-job-address">1363-1385 Sunset Blvd Los Angeles, CA 90026, USA</p>
//                                     <a href="https://themeforest.net/user/thewebmax/portfolio" className="twm-job-websites site-text-primary">https://thewebmax.com</a>
//                                 </div>
//                                 <div className="twm-right-content">
//                                     <div className="twm-jobs-category green"><span className="twm-bg-sky">Freelancer</span></div>
//                                     <div className="twm-jobs-amount">$3000 <span>/ Month</span></div>
//                                     <NavLink to={publicUser.jobs.DETAIL1} className="twm-jobs-browse site-text-primary">Apply Job</NavLink>
//                                 </div>
//                             </div>
//                         </li>
//                     </ul>
//                 </div>
                
//                 <SectionPagination />
//             </div>

//         </>
//     )
// }

// export default CanAppliedJobsPage;